export class TableValueModel {
  productCode: string;
  age: number;
  gender: string;
  sumAssure: number;
  quotationId: number;
  quotationNo?: string;


  constructor(productCode?: string, age?: number, gender?: string, sumAssure?: number, quotationId?: number) {
    this.productCode = productCode;
    this.age = age;
    this.gender = gender;
    this.sumAssure = sumAssure;
    this.quotationId = quotationId;
  }
}
